@if (current_page && !table_view) {
  <div class="series-audit-history">
    <div class="row center" style="justify-content: space-between;height:30px;">
      <h2>Series Edit History</h2>
      <div class="row"
        style="display: flex;align-items: center;justify-content: space-evenly;font-size:0.8em;">
        <button (click)="page(-1)" [class.disabled]="page_number===0"
          [disabled]="page_number===0"
          [matTooltip]="'Previous'"
          class="btn">
          <i class="fa fa-chevron-left"></i>
        </button>
        <button (click)="page(1)" [class.disabled]="page_number===paged_history.length - 1"
          [disabled]="page_number === paged_history.length - 1"
          [matTooltip]="'Next'"
          class="btn">
          <i class="fa fa fa-chevron-right"></i>
        </button>
      </div>
    </div>
    <div class="labels">
      @if (series) {
        <h3>{{series.attributes | nameOrDescription}}</h3>
      }
      <div class="row">
        <label>Change by: </label>
        <div>{{current_page.changed_by_fk}}</div>
      </div>
      <div class="row">
        <label>Changed on:</label>
        <div>{{current_page.changed_on | stringDate}}</div>
      </div>
    </div>
    <div [innerHTML]="current_page.value_string" class="values">
    </div>
    <div class="page-number">
      <span style="color: #999"> {{page_number + 1}} / {{paged_history.length}}</span>
    </div>
  </div>
}

<div class="series-audit-history">
  <h3>Historical Audit Data</h3>
  <series-audit-history-base-table [series]="series" [config]="config">
  </series-audit-history-base-table>


  <h3>Consolidated Audit Data</h3>
  <consolidated-series-audit-history [series]="series">
  </consolidated-series-audit-history>

</div>
